import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
    Box,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Divider,
    Tooltip,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import GroupsIcon from "@mui/icons-material/Groups";
import HistoryIcon from "@mui/icons-material/History";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import LogoutIcon from "@mui/icons-material/Logout";
import TerminalIcon from "@mui/icons-material/Terminal";
import StorageIcon from "@mui/icons-material/Storage";

interface SidebarProps {
    onMobileClose?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onMobileClose }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleNavigation = (path: string) => {
        navigate(path);
        if (onMobileClose) onMobileClose();
    };

    const handleLogout = async () => {
        try {
            await fetch("/auth/logout", {
                method: "POST",
                credentials: "include",
            });
            navigate("/login");
        } catch (error) {
            console.error("Logout failed", error);
        }
    };

    const menuItems = [
        {
            text: "Provas",
            icon: <EmojiEventsIcon />,
            path: "/admin/provas",
        },
        {
            text: "Equipas",
            icon: <GroupsIcon />,
            path: "/admin/equipas",
        },
        {
            text: "Histórico",
            icon: <HistoryIcon />,
            path: "/admin/historico",
        },
        {
            text: "Leaderboard",
            icon: <LeaderboardIcon />,
            path: "/admin/leaderboard",
        },
        {
            text: "Console",
            icon: <TerminalIcon />, // Import this icon
            path: "/admin/console",
        },
        {
            text: "Database", // New menu item
            icon: <StorageIcon />,
            path: "/admin/database",
        },
    ];

    return (
        <Box sx={{ overflow: "auto", height: "100%" }}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    py: 2,
                }}>
                <Box
                    component="img"
                    src="/BotPombal.png"
                    alt="Logo"
                    sx={{
                        width: 120,
                        height: "auto",
                        mb: 1,
                    }}
                />
            </Box>
            <Divider />
            <List>
                <ListItem disablePadding>
                    <Tooltip title="Voltar ao site" placement="right">
                        <ListItemButton onClick={() => navigate("/")}>
                            <ListItemIcon>
                                <HomeIcon />
                            </ListItemIcon>
                            <ListItemText primary="Página inicial" />
                        </ListItemButton>
                    </Tooltip>
                </ListItem>
            </List>
            <Divider />
            <List>
                {menuItems.map((item) => (
                    <ListItem key={item.text} disablePadding>
                        <ListItemButton
                            selected={location.pathname.startsWith(item.path)}
                            onClick={() => handleNavigation(item.path)}>
                            <ListItemIcon>{item.icon}</ListItemIcon>
                            <ListItemText primary={item.text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Divider />
            <List>
                <ListItem disablePadding>
                    <ListItemButton onClick={handleLogout}>
                        <ListItemIcon>
                            <LogoutIcon />
                        </ListItemIcon>
                        <ListItemText primary="Sair" />
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
    );
};

export default Sidebar;
